module.exports = __webpack_public_path__ + "public/adminIcons/defaultAdmin.svg?1105f90c";